import { Container } from "@/shared/components/Container";
import { SectionTag } from "@/shared/components/SectionTag";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { AppLink } from "@/shared/components/AppLink";
import { Reveal } from "@/shared/components/Reveal";
import { usePublishedArticles } from "@/features/content/hooks/usePublishedArticles";
import { useSiteSettings } from "@/features/content/hooks/useSiteSettings";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import { ArticleShowcaseCard } from "./ArticleShowcaseCard";
import styles from "./Articles.module.css";

const SUBSTACK_URL = "https://aurainsights.substack.com/";

export function Articles() {
  const { articlesEnabled } = useSiteSettings();
  const { articles } = usePublishedArticles();
  const locale = useLocale();
  const content = getHomeContent(locale);

  if (!articlesEnabled) {
    return null;
  }

  const featuredArticle = articles.find((article) => article.isFeatured) ?? articles[0];
  const compactArticles = articles.filter((article) => article.id !== featuredArticle?.id).slice(0, 6);

  return (
    <section id="artigos" className={styles.articles}>
      <Container className={styles.content}>
        <Reveal className={styles.header}>
          <SectionTag>{content.articles.tag}</SectionTag>
          <GradientHeading className={styles.title}>
            {content.articles.title}
          </GradientHeading>
          <p className={styles.subtitle}>
            {content.articles.subtitle}
          </p>
        </Reveal>

        {featuredArticle && (
          <Reveal className={styles.showcase} delay={120}>
            <ArticleShowcaseCard article={featuredArticle} variant="featured" />
            {compactArticles.length > 0 && (
              <div className={styles.compactGrid}>
                {compactArticles.map((article) => (
                  <ArticleShowcaseCard
                    key={article.id}
                    article={article}
                    variant="compact"
                  />
                ))}
              </div>
            )}
          </Reveal>
        )}

        <Reveal className={styles.substackCta} delay={180}>
          <img
            className={styles.substackIcon}
            src="/assets/substack 1.svg"
            alt=""
            aria-hidden
            width={50}
            height={50}
          />
          <p>{content.articles.substackText}</p>
          <AppLink
            className={styles.substackButton}
            href={SUBSTACK_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {content.articles.substackButton}
          </AppLink>
        </Reveal>
      </Container>
    </section>
  );
}
